var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84729 3.17585C3.94507 3.26036 4 3.37496 4 3.49446C4 3.61396 3.94507 3.72856 3.84729 3.81307L0.896738 6.36242C0.848625 6.40546 0.791072 6.43979 0.727437 6.46341C0.663803 6.48703 0.595362 6.49946 0.526108 6.49998C0.456853 6.5005 0.388173 6.4891 0.324073 6.46644C0.259973 6.44378 0.201738 6.41032 0.152766 6.36801C0.103794 6.32569 0.0650651 6.27538 0.0388398 6.21999C0.0126145 6.16461 -0.000582109 6.10527 1.96931e-05 6.04543C0.000621495 5.98559 0.0150098 5.92646 0.0423451 5.87148C0.0696803 5.81649 0.109415 5.76677 0.159231 5.7252L2.74103 3.49446L0.159231 1.26373C0.0642215 1.17873 0.0116497 1.0649 0.012838 0.946737C0.0140264 0.828577 0.0688798 0.715548 0.165584 0.631993C0.262288 0.548438 0.393106 0.501044 0.529862 0.500017C0.666617 0.49899 0.798368 0.544414 0.896738 0.626504L3.84729 3.17585Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.9829500dd885aaae273f65205e1f4d72.svg";
export { ForwardRef as ReactComponent };